import { render, staticRenderFns } from "./CrewEducation.vue?vue&type=template&id=370ddc7c&scoped=true&"
import script from "./CrewEducation.vue?vue&type=script&lang=js&"
export * from "./CrewEducation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370ddc7c",
  null
  
)

export default component.exports